import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Image } from 'react-bootstrap';
import httlogo from '../images/httcrop.png';

import m1 from '../images/mcneilus/mcneilus.jpg';
function Mcneilus() {
    return (
        <div>
            <Image
                    src={httlogo}
                    alt="background"
                    style={{
                        top: 0,
                        left: window.innerWidth < 768 ? '110px' : '30px',
                        height: '75px',
                    }}
                />
            <TopMenu />
            <Container>
                <h2 className='htitleb text-center'>McNeilus</h2>
                <div id="truck-box">
                    <Row>
                        <Col md={6}>
                            <Image
                                src={m1}
                                width={'100%'}
                                fluid
                                rounded
                            />
                        </Col>
                        <Col>
                            <p>"Street Smart. Street Tough" </p>
                            <ul>
                                <li>McNeilus garbage trucks pound the streets every day in support of refuse haulers throughout North America and beyond</li>
                                <li>McNeilus has been arming fleets, both big and small, with front loader, rear loader, and side loader packer bodies that stand up to whatever finds its way into the hopper</li>
                                <li>Likewise, McNeilus service and support is just as responsive, ensuring that customers get the parts and service they need — when they need them</li>
                            </ul>
                        </Col>
                    </Row>
                </div>
                <br />
            </Container >
            <BottomMenu />
        </div >
    );
}

export default Mcneilus;